module.exports = __webpack_public_path__ + "img/nullSearch.b0999a47.svg";